import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product, ProductInfo } from '../../models/response';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ChatService } from '../../services/chat.service';
import { SearchService } from '../../services/search.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AnalyticsService } from '../../services/analytics.service';
import { LinkButtonComponent } from '../link-button/link-button.component';

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    MatCheckboxModule,
    LinkButtonComponent
  ],
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss'
})
export class ProductsComponent {
  @Input() product!: Product;
  @Input() selected = false;
  @Input() index = 0;
  @Input() maxCount = 0;
  @Output() showProductPanel = new EventEmitter<ProductInfo>();
  // checkbox option event emitter
  @Output() checkOptionEvent = new EventEmitter<number>();
  // store for showing online link
  @Input() store: string | undefined = '';

  constructor(private router:Router, private chatService: ChatService, private searchService:SearchService, private analyticsService: AnalyticsService) {}

  expandPanel(){
    // Track when the panel is expanded
    this.analyticsService.trackEvent('ask more', {
      product_name: this.product?.ProductName || 'Unknown',
      product_id: this.product?.id || 'Unknown',
      timestamp: new Date().toISOString(),
    });
    this.showProductPanel.emit({
      product: this.product,
      flag: true
    });
  }

  gotoSearch(productName:string | undefined){
    this.chatService.setCurrentRouteInfo('chat');
    if(productName){
      this.searchService.setSearchInputText(productName);
      this.searchService.setSearchRecords(productName);
    }

    this.analyticsService.trackEvent('view_similar_clicked', {
      product_name: productName || 'unknown',
      timestamp: new Date().toISOString()
    });

    this.router.navigate(['search']);
  }

  checkOption(index:number){
    this.checkOptionEvent.emit(index);
  }

  checkValue(value:boolean | undefined){
    return value === false ? true : null;
  }

}
